import { ModalDialog, ModalService } from './modal.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent as SyncfusionDialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: true,
    imports: [
        DialogModule,
        NgClass,
        NgIf,
        TranslateModule,
    ],
})
export class ModalComponent implements OnInit {

  @ViewChild('dialog') dialog: SyncfusionDialogComponent;

  public modalDialog: ModalDialog;

  constructor(public modalService: ModalService,
              private cdr: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.modalService.dialogSubject.subscribe((modalDialog) => {
      const actualDialog = this.modalDialog;
      this.modalDialog = modalDialog;
      if (!modalDialog) {
        this.modalDialog = null;
        this.hideDialog();
      } else {
        this.modalDialog = modalDialog;
        this.showDialog();
        if (actualDialog) {
          this.cdr.detectChanges();
        }
      }
    });
  }

  public okClicked(): void {
    this.hideDialog();
    this.modalDialog.onOkSubject.next();
  }

  public cancelClicked(): void {
    this.hideDialog();
    this.modalDialog.onCancelSubject.next();
  }

  public onClose(eventArgs): void {
    if (eventArgs.isInteracted) {
      this.modalDialog.onCancelSubject.next();
    }
  }

  private hideDialog(): void {
    this.dialog.hide();
    this.dialog.zIndex = 1000;
  }

  private showDialog(): void {
    this.dialog.zIndex = 200000;
    this.dialog.show();
  }
}
